import React, { useEffect, useRef } from 'react';

interface ResponsiveIframeProps {
    url: string;
    title?: string;
}

const ResponsiveIframe: React.FC<ResponsiveIframeProps> = ({ url, title = 'Page content' }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) {
            return;
        }

        const messageHandler = (event: MessageEvent) => {
            console.log('Received message:', event); // debug

            // Check the origin of the message
            if (!url.startsWith(event.origin)) {
                // Ignore messages that do not come from the specified URL's origin
                return;
            }

            if (event.data.type === 'resize') {
                const { height, width } = event.data;
                iframe.style.height = `${height}px`;
                iframe.style.width = `${width}px`;
            }
        };

        window.addEventListener('message', messageHandler);

        // Clean up the event listener when the component unmounts or URL changes
        return () => {
            window.removeEventListener('message', messageHandler);
        };
    }, [url]);

    return (
        <iframe
            ref={iframeRef}
            src={url}
            title={title}
            style={{
                border: 'none',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
            }}
            allowFullScreen
        />
    );
};

export default ResponsiveIframe;
